import { render, staticRenderFns } from "./SubmitForm22.vue?vue&type=template&id=db2d38bc&scoped=true"
import script from "./SubmitForm22.vue?vue&type=script&lang=ts"
export * from "./SubmitForm22.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2d38bc",
  null
  
)

export default component.exports